var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterIcHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "27px",
    viewBox: "0 0 29 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "footerIcHome") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(-19.000000, -18.000000)",
    stroke: "#666666",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "footerIcHome",
    transform: "translate(20.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    points: "0.164473684 9.75197368 13.5055921 0.164473684 26.6467105 9.75197368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69736842,23.9542763 L9.69736842,15.6032895 C9.69736842,15.6032895 10.7967105,13.68125 13.1276316,13.68125 C15.4578947,13.68125 16.5569079,15.6032895 16.5569079,15.6032895 L16.5569079,23.9542763",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    points: "5.04638158 5.54440789 5.04638158 0.164473684 8.03848684 0.164473684 8.03848684 3.65690789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8496711,8.44078947 L24.8496711,22.5417763 C24.8496711,23.7815789 23.8450658,24.7858553 22.6055921,24.7858553 L4.20559211,24.7858553 C2.96578947,24.7858553 1.96151316,23.78125 1.96151316,22.5417763 L1.96151316,8.46052632",
    id: "Stroke-7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcHome);
export default __webpack_public_path__ + "static/media/footerIcHome.8fba118cde75093f611dfd4d54b0a2d0.svg";
export { ForwardRef as ReactComponent };